import { registerLicense } from "@syncfusion/ej2-base";

const licenseKey = import.meta.env.VITE_SYNCFUSION_LICENSE;

if (licenseKey) {
  // Syncfusion reads this before the argument to registerLicense/validateLicense,
  // which avoids Vite/pnpm ending up with a second ej2-base instance that never
  // received the key.
  (window as Window & { syncfusionLicenseKey?: string }).syncfusionLicenseKey =
    licenseKey;
  registerLicense(licenseKey);
}
